import AdCopyMagicItem from '@/entities/AdCopyMagicItem.js';
import ImprovedCopy from '@/entities/ImprovedCopy.js';
import api from '@/services/Api';

export default {
  getList({ page = 1, limit = 10 }) {
    const data = {};
    if (page) {
      data['page'] = page;
    }
    if (limit) {
      data['limit'] = limit;
    }

    const query = new URLSearchParams(data).toString();

    return api().get('/magic-tool/list?' + query)
      .then(resp => resp.map(item => new AdCopyMagicItem(item)));
  },

  get(id) {
    return api().get('/magic-tool/ad-copy-magic-item/' + id)
      .then(resp => new AdCopyMagicItem(resp));
  },

  analyze(text, goal, title, description, image) {
    const formData = new FormData();
    formData.append('text', text);
    formData.append('goal', goal);
    formData.append('title', title);
    formData.append('description', description);
    if (image) {
      formData.append('image', image);
    }

    return api().post('/magic-tool/analyze', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(resp => new AdCopyMagicItem(resp));
  },

  improve({ postId, adCopyMagicItemId }) {
    const data = {};
    if (postId) {
      data['post_id'] = postId;
    }
    else if (adCopyMagicItemId) {
      data['ad_copy_magic_item_id'] = adCopyMagicItemId;
    }

    return api().post('/magic-tool/improve', data)
      .then(resp => new ImprovedCopy(resp));
  },

  delete(id) {
    return api().delete('/magic-tool/ad-copy-magic-item/' + id);
  },
};
